export default __webpack_public_path__ + "static/media/redux.fabcca66.svg";